export default __webpack_public_path__ + "src/assets/images/delault_security.png?8086819a";